// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__05QGd","xs":"styles_xs__kSN18","sm":"styles_sm__eZDD5","md":"styles_md__vI85q","lg":"styles_lg__5Yk4q"};